import Articles from 'components/news/Articles';

export default function News() {
    return <Articles />
}
